import { getFontFamilyStylePure, getPlatformFontEntryByUrlPure } from '@/player-config/src/utils/fontUtils';
import { brandKit, clipsBrandKit, platformBrandKitStore } from '@/stores/brandKit';
import type { PlatformFontEntry } from '@/player-config/src/types/brand-kit-types';
import { currentClip } from '@/stores/clip';
import { currentUser } from '@/stores/user';

// TODO: @AshwinBhatkal to test cases with just extracting from font location
export const getFontFamilyStyle = (clipId: string, fontLocation?: string) => {
  const clip = currentClip.getSnapshot()[clipId];
  const clipBrandKitStore = clipsBrandKit.getSnapshot()[clipId];
  const brandKitStore = brandKit.getSnapshot();
  const platformBrandKit = platformBrandKitStore.getSnapshot();
  const organization = currentUser.getSnapshot()?.organization;
  return getFontFamilyStylePure({
    clip,
    organization,
    clipBrandKitStore,
    brandKitStore,
    platformBrandKit,
    fontLocation
  });
};

/** Returns the full `PlatformFontEntry` (including pre-derived `format`) for a given font URL, if found. */
export const getPlatformFontEntryByUrl = (fontLocation: string | undefined): PlatformFontEntry | undefined => {
  return getPlatformFontEntryByUrlPure({
    fontLocation,
    platformBrandKit: platformBrandKitStore.getSnapshot(),
    organization: currentUser.getSnapshot()?.organization
  });
};
